<template>
    <div class="trailHistory">
        <div class="mapOrList">
            <div class="mapOrListSelector">
                <div class="mapOrListWrapper">
                    <router-link append :to="{query: {...$route.query, view: 'map'}}" class="mapOrListOption">
                        Map
                    </router-link>
                    <router-link append :to="{query: {...$route.query, view: 'list'}}" class="mapOrListOption">
                        List
                    </router-link>
                </div>
            </div>
            <keep-alive>
                <TrailMap class="trailMap"
                          v-if="view === 'map'"
                          :mapCenter="mapCenter"
                          :trails="trails"
                          :selectedTrailId="this.selectedTrail && this.selectedTrail.id"
                          :newLocationMarker="newLocationMarker"
                          v-on:selectTrailId="selectTrailId"/>
                <TrailList class="trailList" v-if="view === 'list'"
                           :trails="trails"
                           :selectedTrail="selectedTrail"
                           v-on:selectTrailId="selectTrailId"/>
            </keep-alive>
        </div>
        <div class="showHideTrailDetails" v-on:click="toggleTrailDetails">
            <span v-if="showTrailDetails">
                arrow_right
            </span>
            <span v-else>
                arrow_left
            </span>
        </div>
        <div class="trailWrapper" v-bind:class="{'trailWrapper-hidden' : !showTrailDetails}">
            <button class="closeX" v-if="showTrailDetails" v-on:click="closeTrailDetails">close</button>
            <Trail ref="trail" @cancelNewTrail="selectFirstTrail" @newLocationMarker="location => this.newLocationMarker = location" class="selectedTrail" v-if="selectedTrail" :trail="selectedTrail" :edit="true" @savedTrail="addUpdateTrail"  @panMap="coords => {this.mapCenter = coords}"/>
        </div>
    </div>
</template>


<script>
  import TrailDao from "../daos/TrailDao";
  import HasherDao from "../daos/HasherDao";
  import Vue from "vue";
  import _ from "lodash-es";
  export default {
    props: ["selectedTrailId", "view"],
    name: 'Trails',
    data: function () {
      return {
        trailsPromise : TrailDao.getAll(),
        trails : [],
        selectedTrail: null,
        trailId: null,
        mapOrList : null,
        listLoaded: false,
        mapLoaded: false,
        showTrailDetails: null,
        mapCenter: null,
        newLocationMarker: null
      }
    },
    created: function() {
      this.trailsPromise.then(allTrails => {
        this.trails = allTrails.sort((trail1, trail2) => trail1 < trail2 ? -1 : 1);
      });
    },
    beforeRouteUpdate(to, from, next) {
      //TODO only if trail id is changing, not if view changing
      this.confirmLeave(to, next);
    },
    beforeRouteLeave(to, from, next) {
      this.confirmLeave(to, next);
    },
    watch: {
      selectedTrailId: {
        immediate: true,
        handler: function (trailId) {
          if (trailId === "new") {
            this.selectedTrail = TrailDao.emptyNewTrail();
            this.setShowTrailDetails(true, true);
          } else if (typeof trailId === "number" || typeof trailId === "string") {
            trailId = Number(trailId);
            if (!this.selectedTrail || this.selectedTrail.id !== trailId) {
              //Fetch if we have no trail fetched, or we have the wrong trail fetched
              TrailDao.fetchById(trailId).then(trail => {
                HasherDao.fetchByIds(trail.hasherIds.concat(trail.hasherIds));
                this.selectedTrail = trail;
                this.setShowTrailDetails(true);
              });
            }
          } else if (this.selectedTrail) {
            //If nothing in the URL but we still have a trail selected (from a previous activation), update the router to the selected trail
            this.selectTrailId(this.selectedTrail.id);
          } else {
            this.selectFirstTrail();
          }
        }
      },
      view: {
        immediate: true,
        handler: function (view, oldView) {
          if (!(view === "map" || view === "list")) {
            if ((oldView === "map" || oldView === "list")) {
              //If nothing in the URL but we still have a view selected (from a previous activation), update the router to the selected view
              this.$router.replace({query: {...this.$route.query, view: oldView}, params: this.$route.params});
            } else {
              this.$router.replace({query: {...this.$route.query, view: "map"}, params: this.$route.params});
            }
          }
        }
      }
    },
    methods: {
      confirmLeave(to, next) {
        let trailVue = this.$refs.trail;
        if ((this.selectedTrail && to.params) && (this.selectedTrail.id == to.params.selectedTrailId)) {
          //Not actually leaving - adjusting view, or moving to saved trail with newly created id
          next();
        } else if (trailVue && trailVue.isDirty) {
          if (!window.confirm("You have unsaved changes, are you sure you want to leave the page?")) {
            next(false);
          } else {
            this.$refs.trail.cancel();
            next();
          }
        } else {
          next();
        }
      },
      setShowTrailDetails(boolean, force)  {
        if (boolean === false || force) {
          //Always respect false and force
          this.showTrailDetails = boolean;
        } else if (this.showTrailDetails === null) {
          //initial set, hide if mobile
          let isSmallScreen = window.matchMedia("(max-width: 992px)").matches;
          if (isSmallScreen) {
            this.showTrailDetails = false;
            //this.$router.replace({query: {...this.$route.query, view: "list"}, params: this.$route.params});
          } else {
            this.showTrailDetails = true;
          }
        } else if (boolean === true) {
          this.showTrailDetails = true;
        }  else {
          console.log("Invalid Boolean " + boolean);
          throw "Invalid Boolean " + boolean;
        }
      },
      addUpdateTrail(newOrUpdatedTrail) {
        this.newLocationMarker = null;
        if (newOrUpdatedTrail) {
          let existingTrailIndex = _.indexOf(this.trails.map(trail => trail.id), newOrUpdatedTrail.id);
          if (existingTrailIndex === -1) {
            //new trail
            this.trails.push(newOrUpdatedTrail);
            this.selectedTrail = newOrUpdatedTrail;
            this.selectTrailId(newOrUpdatedTrail.id);
            //Todo make this happen automatically with another pull from server or other way. Should also do with trail reordering
            TrailDao.fetchById(newOrUpdatedTrail.previousTrailId, undefined, {force: true}).then({

            });
          } else {
            Vue.set(this.trails, existingTrailIndex, newOrUpdatedTrail);
            this.selectedTrail = newOrUpdatedTrail;
          }
        }
      },
      selectFirstTrail: function() {
        this.trailsPromise.then(allTrails => {
          //TODO: remove exceptions for new
          if (!this.selectedTrailId || this.selectedTrailId === "new") {
            //Only set if something else hasn't selected a trail in the meantime
            this.selectTrailId(allTrails.slice(0).sort((trail1, trail2) => (trail1.trailOrdinal - trail2.trailOrdinal))[0].id);
          }
        });
      },
      selectTrailId: function(trailId) {
        if (trailId === this.selectedTrailId) {
          this.setShowTrailDetails(true);
        }  else {
          this.$router.replace({query: this.$route.query, params: {"selectedTrailId": trailId}});
        }
      },
      closeTrailDetails : function() {
        this.setShowTrailDetails(false);
      },
      toggleTrailDetails: function() {
        this.setShowTrailDetails(!this.showTrailDetails);
      }
    }
  }
</script>

<style scoped lang="scss">
    .showHideTrailDetails {
        box-shadow: -2px 1px 2px rgba(0, 0, 0, 0.3);
        margin-top: 1.5em;
        margin-left: -1em;
        height: 2.5em;
        width: 1em;
        font-family: 'Material Icons';
        text-decoration: none;
        user-select: none;
        outline: none;
        font-size: 16px;
        cursor: pointer;
        z-index: 100;
        display: grid;
        align-content: center;
        text-align: center;
        background: rgba(255, 255, 255, 0.9);
    }


    $selector-height: 2em;
    $selector-padding: 0.3em;
    $selector-height-padding: $selector-height + $selector-padding;
    .trailHistory {
        display: flex;
        justify-content: space-between;
        position:relative;
        overflow:hidden;
        //box-shadow: -10px 10px 20px rgba(0, 0, 0, 0.7);
        @media only screen and (max-width: 868px) {
            width: 100%;
            margin: 0;
        }

        .mapOrList {
            flex-grow: 1;
            min-width: 300px;
            min-height: 300px;
            max-width: 100%;
            height: 100%;
            /*flex-basis: 70%;*/
            //margin-right: 1em;
            position:relative;
            .trailMap {
                width: 100%;
                height: 100%;
                min-width: 300px;
                min-height: 300px;
                //max-height viewport calculation - fixed? Collapse pack when too big
                display: flex;
                flex-direction: column;
                align-self: stretch;
            }

            .trailList {
                padding-top: 3em;
                background: white;
                box-sizing: border-box;
            }
        }
        .trailWrapper {
            z-index: 95;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.33);
            /*flex-basis: 30%;*/
            /*min-width: 400px;*/
            /*max-width: 550px;*/
            width: 450px;
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
            padding: 0 1em;
            //z-index: 100; //breaks safari for some reason. not needed?
            background: white;
            will-change: width;
            transition-property: -webkit-transform,transform,opacity,width,margin-right;
            transition-duration: 0.2s;
            transition-timing-function: cubic-bezier(0.0,0.0,0.2,1);

        }
        .trailWrapper.trailWrapper-hidden {
            position: initial;
            margin-right: -450px;
            box-shadow: none;
        }
        .closeX {
            display: none;
        }

        @media only screen and (max-width: 568px) {
            .trailWrapper {
                position: absolute;
                width: 100%;
                height: 100%;
                transition-property: none;
                z-index: 1000;
            }
            .trailWrapper.trailWrapper-hidden {
                margin-right: -100%;
            }
            .closeX {
                display: initial;
                position: absolute;
                left: 0.4rem;
                top: 0.4rem;
                font-family: 'Material Icons';
                text-decoration: none;
                user-select: none;
                outline: none;
                font-size: 24px;
                padding: 4px;
                cursor: pointer;
                z-index: 1;
            }

            .closeX {
                font-size: 36px;
            }
        }
    }

    .mapOrListSelector {
        cursor: pointer;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0.5em;
        z-index: 100;
        //Since this ends up being width 100% as I couldn't figure out a better way to poisition it over and centered.   Is reset by pointer-events:all below.
        pointer-events: none;
        .mapOrListWrapper {
            display: flex;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
            width: 8em;
            margin: auto;
        }


        .mapOrListOption {
            pointer-events: all;
            flex: 1 1 0;
            border-color: $beaverpurple;
            border-style: solid;
            padding: 0 1em;
            height: 2em;
            width: 4em;

            display: flex;
            align-items: center;

            text-decoration: none;
            color: $beaverpurple;
            font-weight: bold;
            background-color: white;
        }
        $mapOrListBorderRadius: 3px;

        .mapOrListOption.router-link-exact-active {
            background-color: lavender;
        }
        .mapOrListOption:first-child {
            border-width: 1px 0 1px 1px;
            border-top-left-radius: $mapOrListBorderRadius;
            border-bottom-left-radius: $mapOrListBorderRadius;
        }

        .mapOrListOption:last-child {
            border-width: 1px;
            border-top-right-radius: $mapOrListBorderRadius;
            border-bottom-right-radius: $mapOrListBorderRadius;
        }
    }
</style>
